import React from 'react';

interface SocialNetworkIconProps {
  size?: number;
  className?: string;
}

export const SocialNetworkIcon: React.FC<SocialNetworkIconProps> = ({ 
  size = 32,
  className = "" 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Gradient Definition */}
      <defs>
        <linearGradient id="socialNetworkGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#22D3EE" /> {/* cyan-400 */}
          <stop offset="50%" stopColor="#4ADE80" /> {/* green-400 */}
          <stop offset="100%" stopColor="#FACC15" /> {/* yellow-400 */}
        </linearGradient>
      </defs>
      
      {/* Background Circle with Gradient */}
      <circle cx="32" cy="32" r="30" fill="url(#socialNetworkGradient)" opacity="0.2" />
      <circle cx="32" cy="32" r="28" fill="url(#socialNetworkGradient)" />
      
      {/* Network Nodes (corner dots) */}
      <circle cx="14" cy="14" r="2.5" fill="white" opacity="0.6" />
      <circle cx="50" cy="14" r="2.5" fill="white" opacity="0.6" />
      <circle cx="14" cy="50" r="2.5" fill="white" opacity="0.6" />
      <circle cx="50" cy="50" r="2.5" fill="white" opacity="0.6" />
      
      {/* Connection Lines */}
      <line x1="14" y1="14" x2="32" y2="32" stroke="white" strokeWidth="1" opacity="0.3" />
      <line x1="50" y1="14" x2="32" y2="32" stroke="white" strokeWidth="1" opacity="0.3" />
      <line x1="14" y1="50" x2="32" y2="32" stroke="white" strokeWidth="1" opacity="0.3" />
      <line x1="50" y1="50" x2="32" y2="32" stroke="white" strokeWidth="1" opacity="0.3" />
      
      {/* Central Badge Circle */}
      <circle cx="32" cy="32" r="16" fill="white" />
      
      {/* "#1" Text */}
      <text
        x="32"
        y="30"
        fontSize="14"
        fontWeight="bold"
        fill="url(#socialNetworkGradient)"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        #1
      </text>
      
      {/* Mini Paw Print */}
      <g transform="translate(32, 38) scale(0.25)">
        <ellipse cx="0" cy="0" rx="8" ry="10" fill="url(#socialNetworkGradient)" />
        <ellipse cx="-8" cy="-8" rx="5" ry="6" fill="url(#socialNetworkGradient)" />
        <ellipse cx="8" cy="-8" rx="5" ry="6" fill="url(#socialNetworkGradient)" />
        <ellipse cx="-12" cy="-2" rx="4" ry="5" fill="url(#socialNetworkGradient)" />
        <ellipse cx="12" cy="-2" rx="4" ry="5" fill="url(#socialNetworkGradient)" />
      </g>
      
      {/* Sparkle Stars */}
      <g opacity="0.8">
        {/* Top Right Sparkle */}
        <path
          d="M46 22 L47 24 L49 25 L47 26 L46 28 L45 26 L43 25 L45 24 Z"
          fill="white"
        />
        {/* Bottom Left Sparkle */}
        <path
          d="M18 42 L19 44 L21 45 L19 46 L18 48 L17 46 L15 45 L17 44 Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
